import BackendRequest from './BackendRequest';

/** Abstraction layer to BackendRequest.ts */
export default BackendRequest;